import Popper from 'popper.js';

class Areas {
  constructor() {
    this.poppers = [];
    this.areaSelector = $('.lot-selector-area');
    this.popupSelector = $('.lot-selector-popup');
  }

  init() {
    this.setPopper();
    this.popupOnAreaHover();
  }

  setPopper() {
    if ($(window).width() > 769) {
      if (this.areaSelector.length && this.popupSelector.length) {
        this.areaSelector.each((index, area) => {
          const popupTarget = $(area).data('popup-target');
          const popup = $(`.lot-selector-popup[data-popup=${popupTarget}]`);
          
          const popper = new Popper(area, popup, {
            placement: 'left',
          });

          this.poppers.push(popper);
        });
      }
    }
  }

  popupOnAreaHover() {
    if (this.areaSelector.length) {
      this.areaSelector.each((index, element) => {
        const area = $(element);
        const popupTarget = $(area).data('popup-target');
        const popup = $(`.lot-selector-popup[data-popup=${popupTarget}]`);

        area.hover(() => {
          popup.addClass('visible');
        }, () => {
          popup.removeClass('visible');
        });
      });
    }
  }
}

$(document).ready(() => {
  new Areas().init();
});
